/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useFlexionStore } from './Stores';
import axios from 'axios';
import { getText } from './Helpers';

let ProfileDescription = null;

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: '1px dotted pink',
    color: state.isFocused ? 'white' : 'black' && state.isSelected ? 'red' : 'black',
    backgroundColor: state.isFocused
      ? '#3366ff'
      : 'white' && state.isSelected
      ? '#99ccff'
      : 'white',
    padding: 20,
    height: 'auto',
  }),
  control: (provided) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    backgroundColor: !ProfileDescription ? '#ef3340' : 'whitesmoke',
    width: 'inherit',
    height: 'inherit',
  }),
  menu: () => ({
    width: 230,
    backgroundColor: 'white',
    border: '1px solid black',
    height: 400,
    zIndex: 3,
    position: 'relative',
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 400,
  }),
  container: () => ({
    width: 230,
    height: 56,
    gridColumn: '2',
    '@media (max-width: 420px)': {
      gridRow: '2',
      gridColumn: '1',
    },
  }),
  input: (provided) => ({ ...provided }),
  placeholder: (provided) => ({
    ...provided,
    color: !ProfileDescription ? 'white' : 'black',
  }),
};

function Autosuggest(props) {
  const Länge = useFlexionStore((state) => state.Länge);
  const ProfileDesc = useFlexionStore((state) => state.ProfileDesc);
  const setProfileDesc = useFlexionStore((state) => state.setProfileDesc);
  const SerieVal = useFlexionStore((state) => state.SerieVal);
  const Profiles = useFlexionStore((state) => state.Profiles);
  const setSelectedProfile = useFlexionStore((state) => state.setSelectedProfile);
  const setSelectedProfileFetched = useFlexionStore((state) => state.setSelectedProfileFetched);
  const calcGewicht = useFlexionStore((state) => state.calcGewicht);
  const DummyData = useFlexionStore((state) => state.DummyData);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [placeholder, setplaceholder] = useState('');
  const [text, settext] = useState(getText(Sprache));
  const [, setstate] = useState();

  useEffect(() => {
    if (SerieVal === 'BLOCAN®') {
      setplaceholder(text.Autosuggest.Profile);
    } else if (SerieVal === 'Rohre') {
      setplaceholder(text.Autosuggest.Pipe);
    } else if (SerieVal === 'Lineareinheiten') {
      setplaceholder(text.Autosuggest.Linear);
    } else if (SerieVal === 'Dummy') {
      setplaceholder(text.Autosuggest.Dummy);
    } else setplaceholder(text.Autosuggest.Backup);
  }, [SerieVal, text]);

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  useEffect(() => {
    ProfileDescription = ProfileDesc;
    setstate({});
  }, [ProfileDesc]);

  function getProfileData(e) {
    setProfileDesc(e);

    function getDummyData() {
      const id = Profiles.find((profile) => profile.Description === e.value).ID;
      const dummy = DummyData.find((dummy) => dummy.ID === id);
      setSelectedProfile(dummy);
      setSelectedProfileFetched(true);
    }

    if (SerieVal === 'Dummy') {
      getDummyData();
    } else {
      const id = Profiles.find((profile) => profile.Description === e.value).ID;
      axios.get(`https://app.rk-rose-krieger.com/api/flexion/newprofile/${id}`).then((response) => {
        setSelectedProfile(response.data);
        setSelectedProfileFetched(true);
        calcGewicht(Länge);
      });
    }
  }

  return (
    <Select
      placeholder={placeholder}
      options={props.val}
      value={ProfileDesc}
      onChange={(e) => getProfileData(e)}
      styles={customStyles}
    />
  );
}

export default Autosuggest;
